import React from "react";

const LOGO_ASSETS = {
  full: "/brand/ar-flow-full.png",
};

export default function BrandLogo({
  variant = "full",
  size = 36,
  style,
  onClick,
  alt = "AR Flow Sistemas",
}) {
  const source = LOGO_ASSETS[variant] || LOGO_ASSETS.full;

  return (
    <img
      src={source}
      alt={alt}
      onClick={onClick}
      draggable="false"
      style={{
        display: "block",
        width: size,
        height: size,
        objectFit: "contain",
        flex: "0 0 auto",
        ...style,
      }}
    />
  );
}
